const ENV_CONFIG = {
    TOKEN_NAME: "_iam_token_41",
    // 前端
    WMSPDA_HOST: "https://wmspda-ainee-dev1.advai.cn",
    IAM_HOST: "https://accounts-ainee-dev1.advai.cn",
    OMS_HOST: "https://seller-ainee-dev1.advai.cn",
    CHAT_HOST: "https://chat-ainee-dev1.advai.cn",
    WMS_HOST: "https://wms-ainee-dev1.advai.cn",
    PARTNER_HOST: "https://partner-ainee-dev1.advai.cn",
    POS_HOST: "https://pos-ainee-dev1.advai.cn",
    BPO_HOST: "https://bpo-ainee-dev1.advai.cn",
    // 后端
    ERP_API_HOST: "https://api-erp-ainee-dev1.advai.cn",
    BPO_API_HOST: "https://api-bpo-ainee-dev1.advai.cn",
};
var AineeDev1 = {
    "ainee-dev1.advai.cn": ENV_CONFIG,
};

const ENV_CONFIG$1 = {
    TOKEN_NAME: "_iam_token_42",
    // 前端
    WMSPDA_HOST: "https://wmspda-ainee-prestg1.advai.cn",
    IAM_HOST: "https://accounts-ainee-prestg1.advai.cn",
    OMS_HOST: "https://seller-ainee-prestg1.advai.cn",
    CHAT_HOST: "https://chat-ainee-prestg1.advai.cn",
    WMS_HOST: "https://wms-ainee-prestg1.advai.cn",
    PARTNER_HOST: "https://partner-ainee-prestg1.advai.cn",
    POS_HOST: "https://pos-ainee-prestg1.advai.cn",
    BPO_HOST: "https://bpo-ainee-prestg1.advai.cn",
    // 后端
    ERP_API_HOST: "https://api-erp-ainee-prestg1.advai.cn",
    BPO_API_HOST: "https://api-bpo-ainee-prestg1.advai.cn",
};
var AineePrestg1 = {
    "ainee-prestg1.advai.cn": ENV_CONFIG$1,
};

const ENV_CONFIG$2 = {
    TOKEN_NAME: "_iam_token_174",
    // 前端
    WMSPDA_HOST: "https://wmspda-prestg1.advai.cn",
    IAM_HOST: "https://accounts-prestg1.advai.cn",
    OMS_HOST: "https://seller-prestg1.advai.cn",
    CHAT_HOST: "https://chat-prestg1.advai.cn",
    WMS_HOST: "https://wms-prestg1.advai.cn",
    PARTNER_HOST: "https://partner-prestg1.advai.cn",
    POS_HOST: "https://pos-prestg1.advai.cn",
    BPO_HOST: "https://bpo-prestg1.advai.cn",
    // 后端
    ERP_API_HOST: "https://api-erp-prestg1.advai.cn",
    BPO_API_HOST: "https://api-bpo-prestg1.advai.cn",
};
var Prestg1 = {
    "prestg1.advai.cn": ENV_CONFIG$2,
};

const ENV_CONFIG$3 = {
    TOKEN_NAME: "_iam_token_173",
    // 前端
    WMSPDA_HOST: "https://wmspda-prestg2.advai.cn",
    IAM_HOST: "https://accounts-prestg2.advai.cn",
    OMS_HOST: "https://seller-prestg2.advai.cn",
    CHAT_HOST: "https://chat-prestg2.advai.cn",
    WMS_HOST: "https://wms-prestg2.advai.cn",
    PARTNER_HOST: "https://partner-prestg2.advai.cn",
    POS_HOST: "https://pos-prestg2.advai.cn",
    BPO_HOST: "https://bpo-prestg2.advai.cn",
    // 后端
    ERP_API_HOST: "https://api-erp-prestg2.advai.cn",
    BPO_API_HOST: "https://api-bpo-prestg2.advai.cn",
};
var Prestg2 = {
    "prestg2.advai.cn": ENV_CONFIG$3,
};

const ENV_CONFIG$4 = {
    TOKEN_NAME: "_iam_token_172",
    // 前端
    WMSPDA_HOST: "https://wmspda-prestg5.advai.cn",
    IAM_HOST: "https://accounts-prestg5.advai.cn",
    OMS_HOST: "https://seller-prestg5.advai.cn",
    CHAT_HOST: "https://chat-prestg5.advai.cn",
    WMS_HOST: "https://wms-prestg5.advai.cn",
    PARTNER_HOST: "https://partner-prestg5.advai.cn",
    POS_HOST: "https://pos-prestg5.advai.cn",
    BPO_HOST: "https://bpo-prestg5.advai.cn",
    // 后端
    ERP_API_HOST: "https://api-erp-prestg5.advai.cn",
    BPO_API_HOST: "https://api-bpo-prestg5.advai.cn",
};
var Prestg5 = {
    "prestg5.advai.cn": ENV_CONFIG$4,
};

const ENV_CONFIG$5 = {
    TOKEN_NAME: "_iam_token_171",
    // 前端
    WMSPDA_HOST: "https://wmspda-prestg6.advai.cn",
    IAM_HOST: "https://accounts-prestg6.advai.cn",
    OMS_HOST: "https://seller-prestg6.advai.cn",
    CHAT_HOST: "https://chat-prestg6.advai.cn",
    WMS_HOST: "https://wms-prestg6.advai.cn",
    PARTNER_HOST: "https://partner-prestg6.advai.cn",
    POS_HOST: "https://pos-prestg6.advai.cn",
    BPO_HOST: "https://bpo-prestg6.advai.cn",
    // 后端
    ERP_API_HOST: "https://api-erp-prestg6.advai.cn",
    BPO_API_HOST: "https://api-bpo-prestg6.advai.cn",
};
var Prestg6 = {
    "prestg6.advai.cn": ENV_CONFIG$5,
};

const ENV_CONFIG$6 = {
    TOKEN_NAME: "_iam_token_143",
    // 前端
    WMSPDA_HOST: "https://wmspda.advai.net",
    IAM_HOST: "https://accounts.advai.net",
    OMS_HOST: "https://seller.advai.net",
    CHAT_HOST: "https://chat.advai.net",
    WMS_HOST: "https://wms.advai.net",
    PARTNER_HOST: "https://partner.advai.net",
    POS_HOST: "https://pos.advai.net",
    BPO_HOST: "https://bpo.advai.net",
    // 后端
    ERP_API_HOST: "https://api-erp.advai.net",
    BPO_API_HOST: "https://api-bpo.advai.net",
};
var AdvaiNet = {
    "advai.net": ENV_CONFIG$6,
};

const ENV_CONFIG$7 = {
    TOKEN_NAME: "_iam_token",
    // 前端
    WMSPDA_HOST: "https://wmspda.ginee.com",
    IAM_HOST: "https://accounts.ginee.com",
    OMS_HOST: "https://erp.ginee.com",
    CHAT_HOST: "https://chat.ginee.com",
    WMS_HOST: "https://wms.ginee.com",
    PARTNER_HOST: "https://partner.ginee.com",
    POS_HOST: "https://pos.ginee.com",
    BPO_HOST: "https://bpo.ginee.com",
    // 后端
    ERP_API_HOST: "https://bizapi.ginee.com",
    BPO_API_HOST: "https://api-bpo.ginee.com",
};
var GineeCom = {
    "ginee.com": ENV_CONFIG$7,
};

// 环境配置
const envConfigs = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, AineeDev1), AineePrestg1), Prestg1), Prestg2), Prestg5), Prestg6), AdvaiNet), GineeCom);
// 检查域名是否符合规范
const checkHost = (host) => {
    const validDomains = Object.keys(envConfigs).join("|");
    const regex = new RegExp(`^[a-z0-9-_.]+(${validDomains})$`);
    // 测试和dev环境拼接类似-ainee-dev1.advai.cn，生产和阿里环境拼接类似.advai.net
    return regex.test(host);
};
// 获取环境配置
const getEnvConfig = (host) => {
    if (Object.keys(envConfigs).length === 0) {
        return {};
    }
    // 如果不符合规范，返回空对象
    if (!checkHost(host)) {
        return {};
    }
    for (const [domain, config] of Object.entries(envConfigs)) {
        // 如果域名符合规范并且有对应配置，返回对应域名的配置
        if (host.endsWith(domain)) {
            return config;
        }
    }
    // 兜底返回空对象
    return {};
};
// 判断是不是本地域名
const isLocalhost = () => {
    const domain = window.location.hostname; // 获取当前域名
    const localDomains = ["localhost", "127.0.0.1", "::1"]; // IPv6 localhost
    return localDomains.includes(domain);
};
// 获取映射方法
const convertOriginInfo = (envConfig, configs) => {
    let NewMap = {};
    Object.keys(envConfig).forEach((u) => {
        NewMap[u] = configs[u];
    });
    return NewMap;
};
// 将本项目支持的类型字段和返回环境变量的方法传入
const getOriginInfo = (envConfig, getConfigFromLocal, noCache) => {
    var _a;
    let projectEnvConfigs = {};
    const envConfigInfoStr = (_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem("envConfigInfo");
    if (envConfigInfoStr && envConfigInfoStr !== "{}" && !noCache) {
        projectEnvConfigs = JSON.parse(envConfigInfoStr);
        return projectEnvConfigs;
    }
    if (isLocalhost() && getConfigFromLocal) {
        projectEnvConfigs = getConfigFromLocal();
    }
    else {
        const envConfigInfo = getEnvConfig(window.location.host);
        if (envConfigInfo) {
            projectEnvConfigs = convertOriginInfo(envConfig, envConfigInfo);
        }
    }
    if (Object.keys(projectEnvConfigs).length > 0 &&
        typeof projectEnvConfigs === "object" &&
        !noCache) {
        localStorage.setItem("envConfigInfo", JSON.stringify(projectEnvConfigs));
    }
    return projectEnvConfigs;
};

/**
 * 域名映射
 */
const commonInitEnvConfig = {
    TOKEN_NAME: "_iam_token",
    IAM_HOST: window === null || window === void 0 ? void 0 : window.location.origin,
    BPO_HOST: window === null || window === void 0 ? void 0 : window.location.origin,
    OMS_HOST: window === null || window === void 0 ? void 0 : window.location.origin,
    CHAT_HOST: window === null || window === void 0 ? void 0 : window.location.origin,
    WMS_HOST: window === null || window === void 0 ? void 0 : window.location.origin,
    PARTNER_HOST: window === null || window === void 0 ? void 0 : window.location.origin,
    POS_HOST: window === null || window === void 0 ? void 0 : window.location.origin,
    WMSPDA_HOST: window === null || window === void 0 ? void 0 : window.location.origin,
    BPO_API_HOST: window === null || window === void 0 ? void 0 : window.location.origin,
    ERP_API_HOST: window === null || window === void 0 ? void 0 : window.location.origin,
};
// T作为传入的约束，baseEnvConfig作为传入的配置，如果传入的配置为空，则使用commonInitEnvConfig
const getCommonOriginInfo = (baseEnvConfig) => {
    if (!baseEnvConfig) {
        return getOriginInfo(commonInitEnvConfig, () => {
            return commonInitEnvConfig;
        }, true);
    }
    return getOriginInfo(baseEnvConfig, () => {
        return baseEnvConfig;
    }, true);
};

export { getCommonOriginInfo as g };
